// BAG CRAP: "First dibs" sign-up at the bottom of collection pages (Klaviyo).
// Records the same "Requested Sold-Out Item" activity as Notify me, with this collection's
// handle in Collections, so the shopper joins that collection's "Asked for:" segment.
(function () {
  var KLAVIYO_COMPANY_ID = "XRLAjE";
  var REQUEST_METRIC = "Requested Sold-Out Item";

  function buildPanel() {
    var panel = document.getElementById("first-dibs-panel");
    if (panel) return panel;

    var style = document.createElement("style");
    style.textContent =
      "#first-dibs-panel{position:fixed;inset:0;z-index:99999;display:none;align-items:flex-end;justify-content:center;background:rgba(0,0,0,.45)}" +
      "#first-dibs-panel.open{display:flex}" +
      "#first-dibs-panel .fd-box{background:#fff;width:100%;max-width:440px;padding:22px 20px 26px;box-sizing:border-box;position:relative}" +
      "@media (min-width:768px){#first-dibs-panel{align-items:center}}" +
      "#first-dibs-panel .fd-close{position:absolute;top:10px;right:14px;font-size:22px;line-height:1;color:#222;background:none;border:0;cursor:pointer;padding:6px}" +
      "#first-dibs-panel .fd-heading{font-size:16px;text-transform:uppercase;margin:0 0 6px;padding-right:30px}" +
      "#first-dibs-panel .fd-text{font-size:14px;color:#3a3734;margin:0 0 14px;line-height:1.4}" +
      "#first-dibs-panel input[type=email]{width:100%;box-sizing:border-box;border:1px solid #e1e1e1;padding:15px 14px;font-size:16px;margin:0 0 10px;border-radius:0;-webkit-appearance:none}" +
      "#first-dibs-panel .fd-submit{width:100%;border:0;background:#4D04AD;color:#fff;padding:17px 10px;font-size:14px;letter-spacing:1px;text-transform:uppercase;text-align:center;cursor:pointer}" +
      "#first-dibs-panel .fd-submit[disabled]{opacity:.6}" +
      "#first-dibs-panel .fd-msg{font-size:14px;margin:12px 0 0;min-height:1em}" +
      "#first-dibs-panel .fd-msg.error{color:#c0262d}" +
      "#first-dibs-panel .fd-msg.success{color:#4D04AD}";
    document.head.appendChild(style);

    panel = document.createElement("div");
    panel.id = "first-dibs-panel";
    panel.innerHTML =
      '<div class="fd-box" role="dialog" aria-modal="true" aria-labelledby="fd-heading">' +
      '<button type="button" class="fd-close" aria-label="Close">&times;</button>' +
      '<p class="fd-heading heading" id="fd-heading"></p>' +
      '<p class="fd-text"></p>' +
      '<form class="fd-form" novalidate>' +
      '<input type="email" name="email" placeholder="Email address" autocomplete="email" required>' +
      '<button type="submit" class="fd-submit heading">Notify me</button>' +
      "</form>" +
      '<p class="fd-msg" aria-live="polite"></p>' +
      "</div>";
    document.body.appendChild(panel);

    function close() { panel.classList.remove("open"); }
    panel.addEventListener("click", function (e) { if (e.target === panel) close(); });
    panel.querySelector(".fd-close").addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    panel.querySelector(".fd-form").addEventListener("submit", function (e) {
      e.preventDefault();
      var input = panel.querySelector("input[type=email]");
      var msg = panel.querySelector(".fd-msg");
      var submit = panel.querySelector(".fd-submit");
      var email = input.value.trim();

      msg.className = "fd-msg";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.textContent = "Please enter a valid email address.";
        msg.classList.add("error");
        input.focus();
        return;
      }

      submit.disabled = true;
      msg.textContent = "";
      var d = panel.dataset;

      fetch("https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO_COMPANY_ID, {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-06-15" },
        body: JSON.stringify({
          data: {
            type: "event",
            attributes: {
              properties: {
                Source: "First dibs",
                ProductName: "",
                URL: location.origin + "/collections/" + d.handle,
                Collections: [d.handle],
                CollectionNames: [d.name],
                Page: location.pathname
              },
              metric: { data: { type: "metric", attributes: { name: REQUEST_METRIC } } },
              profile: { data: { type: "profile", attributes: { email: email } } }
            }
          }
        })
      })
        .then(function (r) { return r.ok; })
        .catch(function () { return false; })
        .then(function (ok) {
          submit.disabled = false;
          if (ok) {
            msg.textContent = "You're on the list. We'll email you when we list more " + d.name + ".";
            msg.classList.add("success");
            panel.querySelector(".fd-form").style.display = "none";
          } else {
            msg.textContent = "Something went wrong. Please try again.";
            msg.classList.add("error");
          }
        });
    });

    return panel;
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".first-dibs-btn");
    if (!btn) return;
    event.preventDefault();
    var panel = buildPanel();
    var name = btn.getAttribute("data-name") || "";
    panel.dataset.handle = btn.getAttribute("data-handle") || "";
    panel.dataset.name = name;
    panel.querySelector(".fd-heading").textContent = "First dibs on " + name;
    panel.querySelector(".fd-text").textContent = "Most pieces are one of a kind and go fast. Leave your email and we'll tell you when we list more " + name + ".";
    panel.querySelector(".fd-form").style.display = "";
    var msg = panel.querySelector(".fd-msg");
    msg.textContent = "";
    msg.className = "fd-msg";
    panel.classList.add("open");
    var input = panel.querySelector("input[type=email]");
    setTimeout(function () { input.focus(); }, 50);
  });
})();
